import { faker } from '@faker-js/faker';

import { EMaoLegType } from '#shared';

import { generateCaseLabel } from './caseFixtures';
import { generateAirport } from './locationFixtures';

import type { MaoAircraft, MaoTrip } from '#entities';

export const generateTrip = ({
  aircraft,
}: {
  aircraft: MaoAircraft;
}): MaoTrip => {
  const now = Date.now();
  const tripDuration = faker.number.int({ min: 2 * 60, max: 14 * 60 });
  const legsCount = faker.number.int({ min: 1, max: 3 });
  const legDuration = tripDuration / legsCount;
  const tripStart =
    now - faker.number.int({ min: 0, max: tripDuration }) * 60000;
  const caseLabel = generateCaseLabel();

  const trip: MaoTrip = {
    ExternalReference: caseLabel,
    Id: faker.number.int({ min: 1 }),
    TripStartUnix: tripStart,
    TripEndUnix: tripStart + tripDuration * 60000,
    Legs: [],
  };
  for (let i = 0; i < legsCount; i++) {
    const legStart = tripStart + legDuration * i * 60000;
    const legEnd = legStart + legDuration * 60000;
    trip.Legs.push({
      Id: faker.number.int({ min: 1 }),
      OffBlocksUtc: new Date(legStart).toISOString(),
      OffBlocksUtcUnix: legStart,
      OnBlocksUtc: new Date(legEnd).toISOString(),
      OnBlocksUtcUnix: legEnd,
      SectorIndex: i,
      Movement: {
        IsOnBlocks: legEnd < now,
        IsOffBlocks: legStart < now,
        ScheduledOffBlocksUtc: new Date(legStart).toISOString(),
        ScheduledOffBlocksUtcUnix: legStart,
        ScheduledOnBlocksUtc: new Date(legEnd).toISOString(),
        ScheduledOnBlocksUtcUnix: legEnd,
        Aircraft: aircraft,
      },
      ArrivalAirport: generateAirport(),
      DepartureAirport: trip.Legs[i - 1]?.ArrivalAirport
        ? { ...trip.Legs[i - 1].ArrivalAirport }
        : generateAirport(),
      LegType: EMaoLegType.Charter,
      Aircraft: aircraft,
      TripId: trip.Id,
    });
  }
  return trip;
};
